import React from "react";
import dashboardImg from "../assets/dashboard_blurred.png";
import chartImg from "../assets/chart_blurred.png";
import adminImg from "../assets/admin_blurred.png";
import ticketImg from "../assets/ticket_blurred.png";
import storeManagerImg from "../assets/Storemanager.png";

const DemoPage = () => {
  return (
    <div style={{ padding: "2rem", maxWidth: "1100px", margin: "0 auto" }}>
      <h1 style={{ textAlign: "center", marginBottom: "2rem" }}>
        See PBIS Portal in Action
      </h1>

      {/* Step 1 */}
      <Section
        title="1. Give Positive Behavior Tickets"
        description="Staff can quickly recognize students for positive actions using a simple ticket form."
        img={ticketImg}
      />

      {/* Step 2 */}
      <Section
        title="2. Track Student Growth"
        description="Students build points over time, and staff can view trends and engagement."
        img={chartImg}
      />

      {/* Step 3 */}
      <Section
        title="3. Monitor Ticket Data"
        description="Admins and staff can see totals, balances, and activity across students."
        img={dashboardImg}
      />

      {/* Step 4 */}
      <Section
        title="4. Manage Your School System"
        description="Easily manage PBIS values, staff, and system settings in one place."
        img={adminImg}
      />

      {/* Step 5 */}
      <Section
        title="5. Run a School Store"
        description="Students can redeem tickets for rewards using a custom store system."
        img={storeManagerImg}
        showNote={false}
      />
    </div>
  );
};

const Section = ({ title, description, img, showNote = true }) => (
  <div style={{ marginBottom: "3rem" }}>
    <h2 style={{ marginBottom: "0.5rem" }}>{title}</h2>
    <p style={{ marginBottom: "1rem", color: "#475569" }}>{description}</p>

    <img
      src={img}
      alt={title}
      style={{
        width: "100%",
        borderRadius: "10px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      }}
    />

    {showNote && (
      <p style={{ fontSize: "0.8rem", color: "#64748b", marginTop: "0.5rem" }}>
        Sample data shown for demonstration purposes
      </p>
    )}
  </div>
);

export default DemoPage;